<aside *ngIf="isLoggedIn">
  <nav>
    <ul class="nav flex-column">
      <li class="nav-item" *ngIf="!isDirEndUser">
        <a class="nav-link" href="https://portal.lsretail.com/">LS Retail Portal</a>
      </li>
      <li class="nav-item">
        <div class="d-flex">
          <span
            class="nav-item__toggle collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#bc"
            aria-expanded="false"
            (click)="togleMenuGroup('BC')"
          >
            <i *ngIf="menuToggle['BC']" class="bi bi-chevron-up"></i>
            <i *ngIf="!menuToggle['BC']" class="bi bi-chevron-down"></i>
            <a class="nav-link" href="#">Business Hub</a>
          </span>
        </div>
        <div class="collapse show" id="bc">
          <ul class="submenu nav flex-column ml-4">
            <li class="nav-item">
              <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
            </li>
            <li
              class="nav-item"
              *ngxPermissionsOnly="[
                constants.Role.BCADMIN,
                constants.Role.BCACCOUNT,
                constants.Role.BCSUPER,
                constants.Role.BCVIEWER
              ]"
            >
              <div *ngIf="menuVisible">
                <a class="nav-link" routerLink="/account-info" routerLinkActive="active">Account information</a>
              </div>
            </li>

            <li class="nav-item" *ngxPermissionsOnly="[constants.Role.CUSTOMERVISIBLE]">
              <div *ngIf="menuVisible">
                <a class="nav-link" routerLink="/customers" routerLinkActive="active">Customers</a>
              </div>
            </li>
            <li
              class="nav-item"
              *ngxPermissionsOnly="[
                constants.Role.BCADMIN,
                constants.Role.BCINVOICE,
                constants.Role.BCSUPER,
                constants.Role.BCVIEWER
              ]"
            >
              <div *ngIf="menuVisible">
                <a class="nav-link" routerLink="/invoices" routerLinkActive="active">Invoices</a>
              </div>
            </li>
            <li
              class="nav-item"
              *ngxPermissionsOnly="[constants.Role.BCADMIN, constants.Role.BCSUPER, constants.Role.BCVIEWER]"
            >
              <div *ngIf="menuVisible">
                <a class="nav-link" routerLink="/user-management" routerLinkActive="active">User Management</a>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item" *ngIf="isLsAdmin && !isBcViewer">
        <div class="d-flex">
          <span
            class="nav-item__toggle collapsed"
            data-bs-toggle="collapse"
            data-bs-target="#admin"
            aria-expanded="false"
            (click)="togleMenuGroup('Admin')"
          >
            <i *ngIf="menuToggle['Admin']" class="bi bi-chevron-up"></i>
            <i *ngIf="!menuToggle['Admin']" class="bi bi-chevron-down"></i>
            <a class="nav-link" href="#">Admin</a>
          </span>
        </div>
        <div class="collapse" id="admin">
          <ul class="submenu nav flex-column ml-4">
            <li class="nav-item">
              <a class="nav-link" routerLink="/ehf-replication" routerLinkActive="active">NAV ehf replication</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/admin-users" routerLinkActive="active">Users</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/admin-saltpay" routerLinkActive="active">Card payments</a>
            </li>
            <li class="nav-item" *ngIf="!isDirEndUser && menuVisible">
              <a class="nav-link" routerLink="/logs" routerLinkActive="active">Logs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/unit-cancelation-logs" routerLinkActive="active"
                >Unit Cancelation Logs</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/partner-program" routerLinkActive="active">Partner Program</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</aside>
